import React from 'react';
import IntlContext from '@jetshop/intl/context';
const withContextFormatMessage = callback => (...args) => (
  <IntlContext.Consumer>{t => callback(t)(...args)}</IntlContext.Consumer>
);

const Translate = withContextFormatMessage(t => t);
Translate.rich = withContextFormatMessage(t => t.rich);
Translate.number = withContextFormatMessage(t => t.number);
Translate.date = withContextFormatMessage(t => t.date);
Translate.time = withContextFormatMessage(t => t.time);
Translate.select = withContextFormatMessage(t => t.select);
Translate.plural = withContextFormatMessage(t => t.plural);
Translate.selectordinal = withContextFormatMessage(t => t.selectordinal);
Translate.custom = withContextFormatMessage(t => t.custom);
export const Intl = IntlContext.Consumer;
export default Translate;
